import styles from "./HomePageCatagoryCard.module.css"
export default function HomePageCatagoryCard({img, text}) {
    return(
        <div className={styles.category_card}>
            <div className={styles.category_card_bg} style={{ backgroundImage: `url(${img})` }}></div>
            <div className={styles.category_card_overlay}>
                <div className={styles.category_card_text}>{text}</div>
            </div>
        </div>
    );
}